module.exports = __webpack_public_path__ + "img/input_user_2.7e097425.png";